export const requiredFieldText = "This field is required";

export const searchMinLength = 3;
